export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">关于黑料</h2>
        <div className="mt-8 space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
          <p>
            黑料是一个专注于数字黑料内容聚合的导航平台，致力于为全国用户提供51黑料网、91黑料网、17黑料网以及718黑料等热门数字黑料子品牌的一站式入口服务。
          </p>
          <p>
            平台聚合了51黑料最新发布、91黑料吃瓜内容、17黑料地址导航以及718黑料合集等多元内容形态，每日更新维护各品牌入口地址，确保用户能够安全、稳定、快速地访问目标平台。
          </p>
          <p>
            无论你是资深黑料爱好者还是新用户，黑料都为你整理了最全面的黑料入口导航、最热门的黑料话题榜单以及最完整的黑料合集归档，让你轻松浏览数字黑料系列的全部精彩内容。
          </p>
          <p className="text-foreground-500 text-xs">
            本站仅为内容聚合与入口导航平台，不生产、存储任何第三方内容。所有子品牌内容版权归原平台所有。
          </p>
        </div>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-6 text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-primary-500"></i>
            每日更新
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-primary-500"></i>
            安全加密
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-primary-500"></i>
            全品牌覆盖
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-primary-500"></i>
            免费使用
          </span>
        </div>
      </div>
    </section>
  );
}